var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{class:['form-tabs', { 'hide-header': _vm.hideHeader }],attrs:{"value":_vm.value,"show-arrows":""},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }